import { Alert, Button, Card, Spinner, Table } from "flowbite-react";
import React, { useEffect, useRef, useState } from "react";
import {
  formatDateToYY,
  formatToReal,
  isValidCNPJ,
  maskCEP,
} from "../../utils/utils";
import axios from "../../config/axiosInstance";
import { QUERIES } from "../../config/apiConfig";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import usePDF from "../../hooks/usePDF";
import TitleStripe from "../common/TitleStripe";
import CardQueryDescription from "../common/CardQueryDescription";
import QueryInput from "../inputs/QueryInput";
import SliderToPreview from "../common/SliderToPreview";
import QueryLoading from "../common/QueryLoading";
import AvisoCard from "../common/query/AvisoCard";
import PendenciasFinanceiras from "../common/query/PendenciasFinanceiras";
import NoOcurrence from "../common/query/NoOcurrence";
import Protestos from "../common/query/Protestos";
import ProtestosDirCartorio from "../common/query/ProtestosDirCartorio";
import ChequesSustados from "../common/query/ChequesSustados";
import ChequesSemFundos from "../common/query/ChequesSemFundos";
import HistoricoConsultas from "../common/query/HistoricoConsultas";
import { EvaluationScorePJ } from "../common/query/EvaluationScorePJ";
import FooterQuery from "./FooterQuery";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { FaPrint } from "react-icons/fa";

const PositivoPlusCNPJQuery = ({
  query,
  selectedPrice,
  dataFromLocalStorage = null,
  hasHeaderPDF = "true",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [document, setDocument] = useState("");
  const [error, setError] = useState("");
  const [errorData, setErrorData] = useState("");
  const [data, setData] = useState(null);
  const [isLoadingProtestos, setIsLoadingProtestos] = useState(false);
  const [infoProtestos, setInfoProtestos] = useState(null);
  const [isDoneRequest, setIsDoneRequest] = useState(false);
  const componentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: componentRef });
  const { handleClickDownloadPDF, pdfURL, setPdfURL } = usePDF(
    componentRef,
    info,
    query?.id,
    isDoneRequest
  );

  useEffect(() => {
    if (dataFromLocalStorage) {
      setData(dataFromLocalStorage.consultaCredito);
      setDocument(dataFromLocalStorage?.consultaCredito?.dadosCadastrais?.cnpj);
      setInfoProtestos(dataFromLocalStorage?.protestosDirCartorio);
      setIsDoneRequest(true);
    }
  }, []);

  const fetchDefineRisco = async (raw) => {
    return await axios(
      `${QUERIES.GET_V2_QUERY}/essencial-plus-cnpj/${info.replace(
        /\D/g,
        ""
      )}?hasProtests=true`
    );
  };

  const fetchInfoProtestos = async (raw) => {
    return await axios(
      `${QUERIES.GET_PROTESTO_NACIONAL}/${info.replace(/\D/g, "")}`
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDocument(info);

    const unmaskedValue = info.replace(/\D/g, "");
    let isValid = true;

    if (!isValidCNPJ(unmaskedValue)) {
      setError("CNPJ inválido!");
      isValid = false;
    }

    if (isValid) {
      try {
        setPdfURL("");
        setData(null);
        setIsLoading(true);
        setError("");
        setErrorData("");
        setInfoProtestos(null);
        setIsDoneRequest(false);

        const { data: dados } = await fetchDefineRisco();
        setData(dados.data.consultaCredito);
        setInfoProtestos(dados.data.protestosDirCartorio);
        setIsLoading(false);

        // try {
        //   const protestos = await fetchInfoProtestos();
        //   if (protestos.data.status !== "success")
        //     throw new Error("erro ao buscar");
        //   setInfoProtestos(protestos.data.data);
        // } catch (protestosError) {
        //   console.error("Erro ao buscar protestos:", protestosError);
        //   setInfoProtestos([]);
        // } finally {
        //   setIsLoadingProtestos(false);
        // }
      } catch (error) {
        setErrorData(
          typeof error?.response?.data?.message !== "object"
            ? error?.response?.data?.message
            : "Algum erro ocorreu com sua consulta"
        );
        setIsLoading(false);
      } finally {
        setIsDoneRequest(true);
      }
    } else {
      setData(null);
    }
  };

  return (
    <div>
      {!dataFromLocalStorage && (
        <>
          <CardQueryDescription
            title={query?.name || "Informações da consulta"}
            infos={[
              "Dados Cadastrais",
              "Score",
              "Negativações",
              "Protestos",
              "Cheques sem fundos",
              "Cheques sustados",
            ]}
            price={selectedPrice}
          >
            <form
              className="flex flex-col gap-2 bg-white p-2 rounded-lg shadow-md w-fit"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col md:flex-row gap-2 items-center">
                <QueryInput
                  info={info}
                  setInfo={setInfo}
                  isLoading={isLoading}
                  error={error}
                  type="CNPJ"
                />
                <div>
                  {!errorData && data && (
                    <Button
                      className="bg-gray-600"
                      onClick={() => reactToPrintFn()}
                    >
                      <div className="flex gap-2 items-center">
                        <FaPrint />
                        <div>Imprimir</div>
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            </form>
          </CardQueryDescription>
        </>
      )}

      <SliderToPreview />

      {errorData ? (
        <Alert color="failure" icon={HiInformationCircle}>
          <span className="font-medium">{errorData}</span>
        </Alert>
      ) : (
        <>
          <div
            className={`overflow-x-scroll print-content  mobile-fit ${
              data || isLoading ? "block" : "hidden"
            }`}
            ref={componentRef}
          >
            {!isLoading ? (
              <>
                <Card className="mt-0 p-4 card-pdf relative overflow-hidden">
                  <HeaderQuery title={query?.name} hasHeader={hasHeaderPDF} />

                  <TitleStripe>Quadro de avisos</TitleStripe>

                  <div className="container-alerts five-columns">
                    <AvisoCard
                      title="Negativações"
                      hasRestrictions={
                        data?.resumoConsulta?.pendenciasFinanceiras
                          ?.quantidadeTotal != 0
                      }
                      messageError={`${data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal}
  ocorrências`}
                    />
                    <AvisoCard
                      title="Cheques sem Fundos"
                      hasRestrictions={
                        data?.resumoConsulta?.chequesSemFundo
                          ?.quantidadeTotal != 0
                      }
                      messageError={`${data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal} 
      ocorrências`}
                    />

                    <AvisoCard
                      title="Cheques Sustados"
                      hasRestrictions={
                        data?.resumoConsulta?.chequesSustados
                          ?.quantidadeTotal != 0
                      }
                      messageError={`${data?.resumoConsulta?.chequesSustados?.quantidadeTotal} ocorrências`}
                    />

                    <AvisoCard
                      title="Protestos"
                      hasRestrictions={
                        data?.resumoConsulta?.protestos?.quantidadeTotal != 0
                      }
                      messageError={`${data?.resumoConsulta?.protestos?.quantidadeTotal} ocorrências`}
                    />

                    {isLoadingProtestos ? (
                      <div className="flex relative flex-col bg-gray-500 rounded-md font-semibold pt-1 pb-6 px-2 text-white shadow-md">
                        <div className="text-left text-sm">
                          Protestos dir. cartório
                        </div>
                        <div className="text-center font-semibold w-fit text-green-800 px-2 rounded-md mx-auto mt-4">
                          <Spinner
                            aria-label="Large spinner example"
                            size="md"
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <AvisoCard
                          title="Protestos dir. Cartório"
                          hasRestrictions={infoProtestos?.length > 0}
                          messageError={`${infoProtestos?.length}
        ocorrências`}
                        />
                      </>
                    )}
                  </div>

                  <TitleStripe>Dados Cadastrais</TitleStripe>
                  <div className="flex flex-row gap-16">
                    <div className="text-sm flex-1">
                      <div className="mb-3">
                        <span className="font-semibold">Razão Social: </span>
                        {data?.dadosCadastrais?.razaoSocial || "Não informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Natureza Jurídica:{" "}
                        </span>
                        {data?.dadosCadastrais?.naturezaJuridica ||
                          "Não informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">CNPJ/MF: </span>
                        {document}
                      </div>

                      <div className="mb-3">
                        <span className="font-semibold">CNAE Principal: </span>
                        {data?.dadosCadastrais?.cnae || "Não informado"}
                      </div>

                      <div className="mb-3 flex gap-2 ">
                        <span className="font-semibold">Fundação: </span>
                        <span>
                          {data?.dadosCadastrais?.dataFundacao ||
                            "Não informado"}
                        </span>
                        {data?.dadosCadastrais?.dataFundacao && (
                          <span className="text-blue-500 font-semibold">
                            -{" "}
                            {moment().diff(
                              moment(
                                data?.dadosCadastrais?.dataFundacao,
                                "DD/MM/yyyy"
                              ),
                              "years"
                            )}{" "}
                            anos
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="text-sm flex-1">
                      {/* <div className="mb-3 flex gap-2 items-center">
                        <span className="font-semibold">Situação: </span>
                        <span
                          className={
                            data?.dadosCadastrais?.situacao?.toLowerCase() ===
                            "ativo"
                              ? "bg-primary text-white px-2 rounded-md"
                              : "bg-red-500 text-white px-2 rounded-md"
                          }
                        >
                          {data?.dadosCadastrais?.situacao || "Não informado"}
                        </span>
                        Não informado
                      </div> */}
                      <div className="mb-3">
                        <span className="font-semibold">Endereço: </span>
                        {data?.dadosCadastrais?.endereco || "Sem informação"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Bairro: </span>
                        {data?.dadosCadastrais?.bairro || "Sem informação"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Cidade: </span>
                        {data?.dadosCadastrais?.cidade || "Sem informação"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">CEP: </span>
                        {data?.dadosCadastrais?.cep || "Sem informação"}
                      </div>
                    </div>
                  </div>

                  <div>
                    <TitleStripe>Avaliação preliminar de crédito</TitleStripe>
                  </div>
                  <EvaluationScorePJ
                    data={data}
                    score={data?.score?.score}
                    probability={+data?.score?.probabilidade * 100}
                    type="CNPJ"
                    hideScore={true}
                  />
                  <div>
                    <TitleStripe className="mb-4">Negativações</TitleStripe>

                    {data?.pendenciasFinanceiras?.length > 0 ? (
                      <>
                        <PendenciasFinanceiras
                          quantidadeTotal={
                            data?.resumoConsulta?.pendenciasFinanceiras
                              ?.quantidadeTotal
                          }
                          valorTotal={
                            data?.resumoConsulta?.pendenciasFinanceiras
                              ?.valorTotal
                          }
                          pendenciasFinanceiras={data?.pendenciasFinanceiras}
                        />
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>
                  <div>
                    <TitleStripe className="mb-5">Protestos</TitleStripe>
                    {data?.protestos?.length > 0 ? (
                      <Protestos
                        quantidadeTotal={
                          data?.resumoConsulta?.protestos?.quantidadeTotal
                        }
                        valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                        protestos={data?.protestos}
                      />
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-5">
                      Protestos direto do cartório
                    </TitleStripe>
                    {!isLoadingProtestos ? (
                      <>
                        {infoProtestos?.length > 0 ? (
                          <ProtestosDirCartorio
                            quantidadeTotal={infoProtestos?.length}
                            protestosDirCartorio={infoProtestos}
                          />
                        ) : (
                          <NoOcurrence />
                        )}
                      </>
                    ) : (
                      <div role="status" className="w-full animate-pulse">
                        <div className="h-7 bg-gray-200 rounded-full dark:bg-gray-700 w-full mb-4"></div>{" "}
                      </div>
                    )}
                  </div>
                  <div>
                    <TitleStripe className="mb-5">
                      Cheques sem fundo
                    </TitleStripe>
                    {data?.chequesSemFundo?.length > 0 ? (
                      <>
                        <ChequesSemFundos
                          quantidadeTotal={
                            data?.resumoConsulta?.chequesSemFundo
                              ?.quantidadeTotal
                          }
                          chequesSemFundos={data?.chequesSemFundo}
                        />
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>
                  <div>
                    <TitleStripe className="mb-5">Cheques sustados</TitleStripe>
                    {data?.chequesSustados?.length > 0 ? (
                      <>
                        <ChequesSustados
                          quantidadeTotal={
                            data?.resumoConsulta?.chequesSustados
                              ?.quantidadeTotal
                          }
                          chequesSustados={data?.chequesSustados}
                        />
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-5">Crédito Obtido</TitleStripe>

                    {data?.creditoObtido ? (
                      <>
                        <div className="mt-2 w-full rounded-lg border border-gray-300 overflow-x-auto">
                          <Table>
                            <Table.Head>
                              {data?.creditoObtido?.lista_indicador_comportamento?.item_indicador?.map(
                                (credito, index) => (
                                  <Table.HeadCell
                                    key={index}
                                    className="text-center text-black text-2xs px-1"
                                    style={{ background: "#F2EDE8" }}
                                  >
                                    {formatDateToYY(credito.mes_ano)}
                                  </Table.HeadCell>
                                )
                              )}
                            </Table.Head>
                            <Table.Body className="divide-y">
                              {data?.creditoObtido?.lista_indicador_comportamento?.item_indicador?.map(
                                (credito, index) => (
                                  <Table.Cell
                                    key={index}
                                    className="text-center text-black text-2xs px-1"
                                  >
                                    {formatToReal(
                                      credito.pontuacao_mensal * 1000
                                    ) || "-"}
                                  </Table.Cell>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-5">
                      Percentual de pontualidade (até 5 dias após o vencimento)
                    </TitleStripe>
                    {data?.pagamentoPontual ? (
                      <>
                        <div className="border border-gray-300 rounded-lg mt-2">
                          <Table>
                            <Table.Head>
                              {data?.pagamentoPontual?.lista_indicador_comportamento?.item_indicador?.map(
                                (credito, index) => (
                                  <Table.HeadCell
                                    key={index}
                                    className="text-center text-black text-2xs px-1"
                                    style={{ background: "#F2EDE8" }}
                                  >
                                    {formatDateToYY(credito.mes_ano)}
                                  </Table.HeadCell>
                                )
                              )}
                            </Table.Head>
                            <Table.Body className="divide-y">
                              {data?.pagamentoPontual?.lista_indicador_comportamento?.item_indicador?.map(
                                (credito, index) => {
                                  const valor = parseFloat(
                                    credito?.pontuacao_mensal
                                  );
                                  return (
                                    <Table.Cell
                                      key={index}
                                      className="text-center text-black text-2xs px-1"
                                    >
                                      {!isNaN(valor) ? `${valor}%` : "–"}
                                    </Table.Cell>
                                  );
                                }
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                        <div className="flex justify-center items-center mt-3">
                          <span className="text-green-500 font-semibold">
                            100%
                          </span>{" "}
                          : Pagamentos Pontuais |{" "}
                          <span className="text-red-500 font-semibold ml-1">
                            0%
                          </span>
                          : Pagamentos não pontuais
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-5">
                      Percentual em atrasos
                    </TitleStripe>

                    {data?.pagamentoAtrasado ? (
                      <div className="w-full rounded-lg border border-gray-300 overflow-x-auto">
                        <Table>
                          <Table.Head>
                            <Table.HeadCell
                              className="text-left text-black text-2xs px-1"
                              style={{ background: "#F2EDE8" }}
                            >
                              Tipo
                            </Table.HeadCell>
                            {Object.values(
                              data.pagamentoAtrasado
                            )[0]?.lista_indicador_comportamento?.item_indicador?.map(
                              (item, idx) => (
                                <Table.HeadCell
                                  key={idx}
                                  className="text-center text-black text-2xs px-1"
                                  style={{ background: "#F2EDE8" }}
                                >
                                  {item.mes_ano}
                                </Table.HeadCell>
                              )
                            )}
                          </Table.Head>

                          <Table.Body className="divide-y">
                            {Object.entries(data.pagamentoAtrasado).map(
                              ([sectionKey, sectionValue], i) => {
                                const indicadores =
                                  sectionValue?.lista_indicador_comportamento
                                    ?.item_indicador;

                                if (!Array.isArray(indicadores)) return null;

                                return (
                                  <Table.Row key={i}>
                                    <Table.Cell className="text-left text-black text-2xs font-medium px-1 capitalize font-semibold">
                                      {sectionKey.replaceAll("_", " ")}
                                    </Table.Cell>
                                    {indicadores.map((item, idx) => {
                                      const valor = parseFloat(
                                        item.pontuacao_mensal
                                      );
                                      return (
                                        <Table.Cell
                                          key={idx}
                                          className="text-center text-black text-2xs px-1"
                                        >
                                          {!isNaN(valor) ? `${valor}%` : "–"}
                                        </Table.Cell>
                                      );
                                    })}
                                  </Table.Row>
                                );
                              }
                            )}
                          </Table.Body>
                        </Table>
                      </div>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div className="flex justify-center items-center mt-1">
                    <span className="text-red-500 font-semibold">100%</span> :
                    Pagamentos em atrasos |{" "}
                    <span className="text-green-500 font-semibold ml-1">
                      0%
                    </span>{" "}
                    : Pagamentos em dia
                  </div>

                  <div>
                    <TitleStripe className="mb-5">
                      Compromissos (quantidade de títulos)
                    </TitleStripe>
                    {data?.compromissos ? (
                      <>
                        <div className="border border-gray-300 rounded-lg mt-2 overflow-x-auto">
                          <Table>
                            <Table.Head>
                              {data?.compromissos?.lista_indicador_comportamento?.item_indicador?.map(
                                (credito, index) => (
                                  <Table.HeadCell
                                    key={index}
                                    className="text-center text-black text-2xs px-1"
                                    style={{ background: "#F2EDE8" }}
                                  >
                                    {formatDateToYY(credito.mes_ano)}
                                  </Table.HeadCell>
                                )
                              )}
                            </Table.Head>

                            <Table.Body className="divide-y">
                              <Table.Row>
                                {data?.compromissos?.lista_indicador_comportamento?.item_indicador?.map(
                                  (credito, index) => {
                                    const valor = parseFloat(
                                      credito.pontuacao_mensal
                                    );
                                    return (
                                      <Table.Cell
                                        key={index}
                                        className="text-center text-black text-2xs px-1"
                                      >
                                        {!isNaN(valor) ? valor * 100 : "–"}
                                      </Table.Cell>
                                    );
                                  }
                                )}
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-5">
                      Comprometimento Futuro
                    </TitleStripe>
                    {data?.comprometimentoFuturo ? (
                      <>
                        <div className="font-semibold mt-2">Compromissos</div>

                        <div className="border border-gray-300 rounded-lg mt-2 overflow-x-auto">
                          <Table>
                            <Table.Head>
                              {data?.comprometimentoFuturo?.lista_compromissos?.compromisso?.map(
                                (credito, index) => (
                                  <Table.HeadCell
                                    key={index}
                                    className="text-center text-black text-2xs px-1"
                                    style={{ background: "#F2EDE8" }}
                                  >
                                    {formatDateToYY(credito.periodo)}
                                  </Table.HeadCell>
                                )
                              )}
                            </Table.Head>

                            <Table.Body className="divide-y">
                              <Table.Row>
                                {data?.comprometimentoFuturo?.lista_compromissos?.compromisso?.map(
                                  (credito, index) => {
                                    const valor = parseFloat(credito.pontuacao);
                                    return (
                                      <Table.Cell
                                        key={index}
                                        className="text-center text-black text-2xs px-1"
                                      >
                                        {!isNaN(valor) ? valor * 100 : "–"}
                                      </Table.Cell>
                                    );
                                  }
                                )}
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        </div>

                        <div className="font-semibold mt-5">Crédito</div>
                        <div className="border border-gray-300 rounded-lg mt-2 overflow-x-auto">
                          <Table>
                            <Table.Head>
                              {data?.comprometimentoFuturo?.lista_credito?.credito?.map(
                                (credito, index) => (
                                  <Table.HeadCell
                                    key={index}
                                    className="text-center text-black text-2xs px-1"
                                    style={{ background: "#F2EDE8" }}
                                  >
                                    {formatDateToYY(credito.periodo)}
                                  </Table.HeadCell>
                                )
                              )}
                            </Table.Head>

                            <Table.Body className="divide-y">
                              <Table.Row>
                                {data?.comprometimentoFuturo?.lista_credito?.credito?.map(
                                  (credito, index) => {
                                    const valor = parseFloat(credito.pontuacao);
                                    return (
                                      <Table.Cell
                                        key={index}
                                        className="text-center text-black text-2xs px-1"
                                      >
                                        {!isNaN(valor)
                                          ? formatToReal(valor * 1000)
                                          : "–"}
                                      </Table.Cell>
                                    );
                                  }
                                )}
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-5">
                      Histórico de consultas
                    </TitleStripe>

                    {data?.historicoConsultas?.length > 0 ? (
                      <div className="flex flex-col gap-2">
                        <div className="flex-1">
                          <HistoricoConsultas
                            historicoConsultas={data?.historicoConsultas?.slice(
                              0,
                              5
                            )}
                          />
                        </div>
                        {/* {data?.historicoConsultasResumo
                          ?.paresMesAnoHistoricoConsultas?.length > 0 && (
                          <ReactApexChart
                            className="border border-gray-200 rounded-md mt-3"
                            options={{
                              chart: {
                                height: 150,
                                type: "bar",
                                toolbar: {
                                  show: false, // Remove o menu de ações
                                },
                              },
                              plotOptions: {
                                bar: {
                                  borderRadius: 2,
                                  dataLabels: {
                                    position: "center", // top, center, bottom
                                  },
                                },
                              },
                              dataLabels: {
                                enabled: true,
                                formatter: function (val) {
                                  return val;
                                },
                                offsetY: 0,
                                style: {
                                  fontSize: "12px",
                                  colors: ["white"],
                                },
                              },

                              xaxis: {
                                categories:
                                  data?.historicoConsultasResumo
                                    ?.paresMesAnoHistoricoConsultas,
                                position: "top",
                                axisBorder: {
                                  show: false,
                                },
                                axisTicks: {
                                  show: false,
                                },
                                crosshairs: {
                                  fill: {
                                    type: "gradient",
                                    gradient: {
                                      colorFrom: "#309ADB",
                                      colorTo: "#309ADB",
                                      stops: [0, 100],
                                      opacityFrom: 0.4,
                                      opacityTo: 0.5,
                                    },
                                  },
                                },
                                tooltip: {
                                  enabled: true,
                                },
                              },
                              yaxis: {
                                axisBorder: {
                                  show: false,
                                },
                                axisTicks: {
                                  show: false,
                                },
                                labels: {
                                  show: false,
                                  formatter: function (val) {
                                    return val;
                                  },
                                },
                              },
                              title: {
                                text: "Últimos 12 meses",
                                floating: true,
                                offsetY: 200,
                                align: "center",
                                style: {
                                  color: "#444",
                                },
                              },
                            }}
                            series={[
                              {
                                name: "Qtd. Consultas no período",
                                data: data?.historicoConsultasResumo
                                  ?.totaisHistoricoConsultas,
                              },
                            ]}
                            type="bar"
                            height={220}
                          />
                        )} */}
                      </div>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  {/* <div>
                    <TitleStripe className="mb-3">
                      Histórico de endereços
                    </TitleStripe>
                    {data?.dadosCadastrais?.enderecos?.length > 0 ? (
                      <>
                        <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                          <Table striped>
                            <Table.Head>
                              <Table.HeadCell className="bg-gray-300 p-2">
                                Endereço
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Bairro
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Cidade:
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                CEP:
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Prioridade:
                              </Table.HeadCell>
                            </Table.Head>

                            <Table.Body className="divide-y">
                              {data?.dadosCadastrais?.enderecos?.map(
                                (endereco, index) => (
                                  <Table.Row
                                    key={index}
                                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                  >
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white p-2">
                                      {endereco.endereco} Nº {endereco.numero}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {endereco.bairro}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {endereco.cidade}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {endereco.cep}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {endereco.prioridade}
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>
                  <div>
                    <TitleStripe className="mb-3">
                      Histórico de emails
                    </TitleStripe>
                    {data?.dadosCadastrais?.emails?.length > 0 ? (
                      <>
                        <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                          <Table striped>
                            <Table.Head>
                              <Table.HeadCell className="bg-gray-300 p-2">
                                Email
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Prioridade
                              </Table.HeadCell>
                            </Table.Head>

                            <Table.Body className="divide-y">
                              {data?.dadosCadastrais?.emails?.map(
                                (email, index) => (
                                  <Table.Row
                                    key={index}
                                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                  >
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white p-2">
                                      {email.email}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {email.prioridade}
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-3">
                      Histórico de telefones
                    </TitleStripe>
                    {data?.dadosCadastrais?.telefones?.length > 0 ? (
                      <>
                        <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                          <Table striped>
                            <Table.Head>
                              <Table.HeadCell className="bg-gray-300 p-2 text-center">
                                DDD
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Número
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Prioridade:
                              </Table.HeadCell>
                            </Table.Head>

                            <Table.Body className="divide-y">
                              {data?.dadosCadastrais?.telefones?.map(
                                (telefone, index) => (
                                  <Table.Row
                                    key={index}
                                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                  >
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white p-2 text-center">
                                      {telefone.ddd}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {telefone.numero}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {telefone.prioridade}
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div>

                  <div>
                    <TitleStripe className="mb-3">
                      Histórico de celulares
                    </TitleStripe>
                    {data?.dadosCadastrais?.celulares?.length > 0 ? (
                      <>
                        <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                          <Table striped>
                            <Table.Head>
                              <Table.HeadCell className="bg-gray-300 p-2 text-center">
                                DDD
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Número
                              </Table.HeadCell>
                              <Table.HeadCell className="text-center bg-gray-300 p-2">
                                Prioridade:
                              </Table.HeadCell>
                            </Table.Head>

                            <Table.Body className="divide-y">
                              {data?.dadosCadastrais?.celulares?.map(
                                (telefone, index) => (
                                  <Table.Row
                                    key={index}
                                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                  >
                                    <Table.Cell className="font-medium text-gray-900 dark:text-white p-2 text-center">
                                      {telefone.ddd}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {telefone.numero}
                                    </Table.Cell>
                                    <Table.Cell className="text-center p-2">
                                      {telefone.prioridade}
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    ) : (
                      <NoOcurrence />
                    )}
                  </div> */}

                  <FooterQuery hasHeader={hasHeaderPDF} />
                </Card>
              </>
            ) : (
              <QueryLoading />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PositivoPlusCNPJQuery;
